import { Component, OnInit } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { CompressionService } from '../compression.service';

@Component({
  selector: 'app-word-compression',
  templateUrl: './word-compression.component.html',
  styleUrls: ['./word-compression.component.css']
})
export class WordCompressionComponent extends GeneralExerciseComponent {

  text: string;
  compressedText: string;

  errors: number[] = [];

  absolute: boolean;
  relative: boolean;
  highlight: boolean;

  toHighlight: number[] = [];
  caretPosition: number;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected compressionService: CompressionService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration() {
    this.text = this.configuration.typespecifics.text;
    this.absolute = this.configuration.typespecifics.absolute;
    this.relative = this.configuration.typespecifics.relative;
    this.highlight = this.configuration.typespecifics.highlight;

    this.compressedText = "";
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.compressedText) {
        this.compressedText = this.state.typespecific.compressedText;
      }
    }
  }

  computeState() {
    this.state.typespecific.compressedText = this.compressedText;
  }

  checkSolution() {
    let solution = this.compressionService.compress(this.text, this.absolute, this.relative);
    let studentSolution = this.compressedText;
    let studentDecompressed = this.compressionService.decompress(studentSolution).split(" ");

    this.errors = this.text.split(" ").map((v, i) => [v, i]).filter(v => v[0] != studentDecompressed[v[1]]).map(v => +v[1]);

    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    } else {
      if (studentSolution.length > solution.length) {
        this.errors = solution.split(" ").map((v, i) => [v, i]).filter(v => v[0].toString().length < studentSolution.split(" ")[v[1]].length).map(v => +v[1]);
        this.messageService.addAlertWithTimeout(this.get("notMinimalCompression"), "danger", 10000);
      } else if ((!this.relative && studentSolution.includes("+"))) {
        this.errors = solution.split(" ").map((v, i) => [v, i]).filter(v => v.includes("+")).map(v => +v[1]);
        this.messageService.addAlertWithTimeout(this.get("wrongCompressionUsedRelative"), "danger", 10000);
      } else if ((!this.absolute && studentSolution.includes("#"))) {
        this.errors = solution.split(" ").map((v, i) => [v, i]).filter(v => v.includes("#")).map(v => +v[1]);
        this.messageService.addAlertWithTimeout(this.get("wrongCompressionUsedAbsolute"), "danger", 10000);
      } else {
        this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
        this.solved = true;
        this.state.solved = true;
        this.saveState();
      }
    }

  }

  evaluate(): number[] {
    let points = 1;
    if (this.relative && !this.absolute) {
      points = 2;
    } else if (this.relative && this.absolute) {
      points = 3;
    }
    let solution = this.compressionService.compress(this.text, this.absolute, this.relative);
    let studentSolution = this.compressedText;
    let studentDecompressed = this.compressionService.decompress(studentSolution).split(" ");

    let errors = this.text.split(" ").map((v, i) => [v, i]).filter(v => v[0] != studentDecompressed[v[1]]).map(v => +v[1]);

    if (studentSolution.length > solution.length) {
      errors = errors.concat(...solution.split(" ").map((v, i) => [v, i]).filter(v => v[0].toString().length < studentSolution.split(" ")[v[1]].length).map(v => +v[1]));
    } else if ((!this.relative && studentSolution.includes("+"))) {
      errors = errors.concat(...solution.split(" ").map((v, i) => [v, i]).filter(v => v.includes("+")).map(v => +v[1]));
    } else if ((!this.absolute && studentSolution.includes("#"))) {
      errors = errors.concat(...solution.split(" ").map((v, i) => [v, i]).filter(v => v.includes("#")).map(v => +v[1]));
    }

    errors = errors.filter((v, i) => errors.indexOf(v) == i);
    console.log(errors)
    return [(solution.length - errors.length) / solution.length * points, points];
  }

  /** compute the words to highlight */
  setCaret(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      this.caretPosition = oField.selectionStart;
    }

    let currentText = this.text.substr(0, this.caretPosition);
    currentText = currentText.substring(0, currentText.lastIndexOf(" "));

    let index = this.compressedText.substr(0, this.caretPosition).split(" ").length - 1;
    if (!this.compressedText.includes(" ")) {
      index = 0;
    }
    currentText = this.text.split(" ").slice(0, index).join(" ");
    let currentWord = this.text.split(" ")[currentText.length == 0 ? 0 : currentText.split(" ").length];

    let previousWords = currentText.split(" ")

    this.toHighlight = [];

    for (let i = 0; i < currentWord.length + 1; i++) {
      for (let j = i + 3; j < currentWord.length + 1; j++) {
        let prefix = currentWord.substr(i, j);
        if (previousWords.includes(prefix)) {
          if (this.absolute && !this.relative) {
            let start = previousWords.indexOf(prefix);
            this.toHighlight.push(start);
          } else if (!this.absolute && this.relative) {
            this.toHighlight.push(previousWords.lastIndexOf(prefix));
          } else if (this.absolute && this.relative) {
            let start: number = previousWords.indexOf(prefix);
            if (start < previousWords.lastIndexOf(prefix) - index) {
              this.toHighlight.push(start);
            } else {
              this.toHighlight.push(previousWords.lastIndexOf(prefix));
            }
          }
        }
      }
    }
    this.toHighlight.push(index);
  }


  /** is the given word errorneous? */
  inError(i: number) {
    return this.errors.includes(i);
  }

  /** compute the compressed Text */
  normalizeText() {
    this.compressedText = this.compressedText.replace(/[^A-z #0-9+]/gi, '').replace(/\s+/, " ").toUpperCase();
  }



}
